"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var ExpandedItem_1 = __importDefault(require("../../../../BuildingProperties/AmenityList/ExpandedItem"));
var classnames_1 = __importDefault(require("classnames"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var SpecialMortgageRow = function (_a) {
    var mortgage = _a.mortgage;
    var t = react_i18next_1.useTranslation('common').t;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.bl_amenity_list }, mortgage.map(function (item, index) {
        var _a;
        return (react_1.default.createElement("div", { className: "amenity-item", key: index },
            react_1.default.createElement("div", { className: "push-left" }, t(item.name)),
            react_1.default.createElement("div", { className: classnames_1.default('amenity-info', styles_module_scss_1.default.expanded_item) }, !!((_a = item.mortgage_programs) === null || _a === void 0 ? void 0 : _a.length) && (react_1.default.createElement(ExpandedItem_1.default, { data: __spreadArray([], item.mortgage_programs) })))));
    })));
};
exports.default = react_1.memo(SpecialMortgageRow);
